import React, { useState, useEffect } from 'react';
import Header from '../../components/Header';
import Title from '../../components/Title';
import { GiFamilyHouse } from "react-icons/gi";
import { db } from '../../services/firebaseConnection';
import { updateDoc, getDoc, doc, collection, getDocs } from 'firebase/firestore';
import { toast } from 'react-toastify';
import { useParams, useNavigate } from 'react-router-dom';

export default function EditIgreja() {
  const [nome, setNome] = useState('');
  const [rdj, setRDJ] = useState('');
  const [diasRDJ, setDiasRDJ] = useState([]);
  const [diasCulto, setDiasCulto] = useState([]);
  const [cidade, setCidade] = useState('');
  const [cidades, setCidades] = useState([]);
  const [atriu, setAtriu] = useState('Átrio');
  const [corredor, setCorredor] = useState('Pedidos de Oração');
  const [banheiro, setBanheiro] = useState('Sanitário');
  const [estacionamento, setEstacionamento] = useState('Estacionamento');
  const [som, setSom] = useState('Som');
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const igrejaRef = doc(db, 'Igreja', id);
        const igrejaSnap = await getDoc(igrejaRef);

        if (igrejaSnap.exists()) {
          const data = igrejaSnap.data();
          setNome(data.nome);
          setRDJ(data.rdj);
          setDiasRDJ(data.diasRDJ || []);
          setDiasCulto(data.diasCulto || []);
          setCidade(data.cidade);
          setAtriu(data.atriu || 'Átrio');
          setCorredor(data.corredor || 'Pedidos de Oração');
          setBanheiro(data.banheiro || 'Sanitário');
          setEstacionamento(data.estacionamento || 'Estacionamento');
          setSom(data.som || 'Som');
        } else {
          toast.error('Igreja não encontrada.');
          navigate('/igreja');
        }

        const cidadeSnapshot = await getDocs(collection(db, 'Cidade'));
        const cidadeList = cidadeSnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setCidades(cidadeList);
      } catch (error) {
        console.error('Erro ao buscar dados:', error);
        toast.error('Erro ao carregar dados.');
      }
    };

    fetchData();
  }, [id, navigate]);

  const adicionarDiaRDJ = () => {
    setDiasRDJ([...diasRDJ, { dia: '', horario: '' }]);
  };

  const handleDiaRDJChange = (index, campo, valor) => {
    const novosDiasRDJ = [...diasRDJ];
    novosDiasRDJ[index][campo] = valor;
    setDiasRDJ(novosDiasRDJ);
  };

  const removerDiaRDJ = (index) => {
    const novosDiasRDJ = [...diasRDJ];
    novosDiasRDJ.splice(index, 1);
    setDiasRDJ(novosDiasRDJ);
  };

  const adicionarDiaCulto = () => {
    setDiasCulto([...diasCulto, { dia: '', horario: '' }]);
  };

  const handleDiaCultoChange = (index, campo, valor) => {
    const novosDiasCulto = [...diasCulto];
    novosDiasCulto[index][campo] = valor;
    setDiasCulto(novosDiasCulto);
  };

  const removerDiaCulto = (index) => {
    const novosDiasCulto = [...diasCulto];
    novosDiasCulto.splice(index, 1);
    setDiasCulto(novosDiasCulto);
  };

  async function handleEdit(e) {
    e.preventDefault();

    if (nome !== '' && cidade !== '') {
      try {
        const igrejaRef = doc(db, 'Igreja', id);
        await updateDoc(igrejaRef, {
          nome,
          rdj,
          diasRDJ,
          diasCulto,
          cidade,
          atriu,
          corredor,
          banheiro,
          estacionamento,
          som,
        });
        toast.success('Igreja atualizada com sucesso!');
        navigate('/igreja');
      } catch (error) {
        console.error('Erro ao atualizar igreja:', error);
        toast.error('Erro ao atualizar igreja.');
      }
    } else {
      toast.error('Preencha todos os campos.');
    }
  }

  return (
    <div>
      <Header />

      <div className="content">
        <Title name={nome ? `Editar Casa de Oração - ${nome}` : 'Editar Igreja'}>
          <GiFamilyHouse size={25} />
        </Title>

        <div className="container">
          <form className="form-profile" onSubmit={handleEdit}>
            <label>Nome</label>
            <input
              type="text"
              placeholder="Nome da Casa de Oração"
              value={nome}
              onChange={(e) => setNome(e.target.value)}
            />

            <label>Tem Reunião de Jovens e Menores?</label>
            <select
              value={rdj}
              onChange={(e) => setRDJ(e.target.value)}
            >
              <option value="sim">Sim</option>
              <option value="nao">Não</option>
            </select>

            {rdj === 'sim' && (
              <div>
                <h3>Dias de RDJ</h3>
                {diasRDJ.map((dia, index) => (
                  <div className='diasCultos' key={index}>
                    <select
                      value={dia.dia}
                      onChange={(e) => handleDiaRDJChange(index, 'dia', e.target.value)}
                    >
                      <option value="Domingo">Domingo</option>
                      <option value="Segunda">Segunda</option>
                      <option value="Terca">Terça</option>
                      <option value="Quarta">Quarta</option>
                      <option value="Quinta">Quinta</option>
                      <option value="Sexta">Sexta</option>
                      <option value="Sabado">Sábado</option>
                    </select>
                    <input
                      type="time"
                      value={dia.horario}
                      onChange={(e) => handleDiaRDJChange(index, 'horario', e.target.value)}
                    />
                    <button type="button" onClick={() => removerDiaRDJ(index)}>
                      Remover
                    </button>
                  </div>
                ))}
                <button className='addCulto' type="button" onClick={adicionarDiaRDJ}>
                  Adicionar Dia de RDJ
                </button>
              </div>
            )}

            <h3>Dias de Culto</h3>
            {diasCulto.map((dia, index) => (
              <div className='diasCultos' key={index}>
                <select
                  value={dia.dia}
                  onChange={(e) => handleDiaCultoChange(index, 'dia', e.target.value)}
                >
                  <option value="Domingo">Domingo</option>
                  <option value="Segunda">Segunda</option>
                  <option value="Terca">Terça</option>
                  <option value="Quarta">Quarta</option>
                  <option value="Quinta">Quinta</option>
                  <option value="Sexta">Sexta</option>
                  <option value="Sabado">Sábado</option>
                </select>
                <input
                  type="time"
                  value={dia.horario}
                  onChange={(e) => handleDiaCultoChange(index, 'horario', e.target.value)}
                />
                <button type="button" onClick={() => removerDiaCulto(index)}>
                  Remover
                </button>
              </div>
            ))}
            <button className='addCulto' type="button" onClick={adicionarDiaCulto}>
              Adicionar Dia de Culto
            </button>

            <label>Cidade</label>
            <select
              value={cidade}
              onChange={(e) => setCidade(e.target.value)}
            >
              <option value="" disabled>
                Selecione uma cidade
              </option>
              {cidades.map((cidade) => (
                <option key={cidade.id} value={cidade.id}>
                  {cidade.nome}
                </option>
              ))}
            </select>

            <label>Personalizar nome dos locais</label>
            <input
              type="text"
              placeholder="Nome do Átrio"
              value={atriu}
              onChange={(e) => setAtriu(e.target.value)}
            />
            <input
              type="text"
              placeholder="Nome do Pedidos de Oração"
              value={corredor}
              onChange={(e) => setCorredor(e.target.value)}
            />
            <input
              type="text"
              placeholder="Nome do Sanitário"
              value={banheiro}
              onChange={(e) => setBanheiro(e.target.value)}
            />
            <input
              type="text"
              placeholder="Nome do Estacionamento"
              value={estacionamento}
              onChange={(e) => setEstacionamento(e.target.value)}
            />
            <input
              type="text"
              placeholder="Nome do Som"
              value={som}
              onChange={(e) => setSom(e.target.value)}
            />

            <button type="submit">Atualizar</button>
          </form>
        </div>
      </div>
    </div>
  );
}
